<template>
  <v-container fluid>
    <vue-progress-bar></vue-progress-bar>
    <v-flex xs12>
      <v-card style="margin-top: -10px;">
        <v-card-title>

          <v-text-field append-icon="search" label="Quick Search" single-line hide-details v-model="search" clearable style="width: 100px; margin-top: -20px; margin-left: 20px;"></v-text-field>
          <v-spacer></v-spacer>

      <!--UPLOAD-->
      <form enctype="multipart/form-data" novalidate v-if="">
        <div  :class="!dark ? 'dropbox dropbox-light' : 'dropbox'">
          <input type="file" :name="uploadFieldName" :disabled="isSaving" @change="filesChange($event.target.name, $event.target.files); fileCount = $event.target.files.length" ref="fileInput"
            accept="*.pdf" class="input-file">
            <p v-if="isInitial">
              Для проверки перетяните сюда pdf файл<br> или кликните для выбора
            </p>
            <p v-if="isSuccess" style="font-size: 20px; font-weight: bold; color: black;">
              {{ result }} &nbsp;&nbsp;&nbsp;
              <v-btn fab small class="grey" @click.native="reset()" style=" margin-top: -0px;">
                <v-icon>cancel</v-icon>
              </v-btn>
            </p>
            <p v-if="isSaving">
              Выполняется проверка...
            </p>
        </div>
      </form>
      <div v-if="isFailed">
        <h2>Uploaded failed.</h2>
        <p>
          <a href="javascript:void(0)" @click="reset()">Try again</a>
        </p>
      </div>

            <v-btn class="brown lighten-1" fab small dark @click.native="reloadData()">
              <v-icon>refresh</v-icon>
            </v-btn>
            <table>
            <v-btn fab small flat class="grey" @click.native="getJSON()" style="font-size: 8px;">
                JSON
              </v-btn>
              </table>
        </v-card-title>

        <v-data-table class="elevation-1" v-bind:headers="headers" v-bind:items="items" :search="search" v-bind:pagination="pagination" hide-actions style="white-space: nowrap; margin-top: -10px;">
            <template slot="headers" slot-scope="props">
                <tr>
                  <th style="max-width: 30px;">ID проверки</th>
                  <th style="max-width: 30px;">Сотрудник</th>
                  <th style="max-width: 30px;">Вес файла</th>
                  <th style="max-width: 30px;">Отправитель</th>
                  <th style="max-width: 30px;">Получатель</th>
                  <th style="max-width: 30px;">Сумма</th>
                  <th style="max-width: 30px;">Время платежа</th>
                  <th style="max-width: 30px;">Время проверки</th>
                  <th style="max-width: 30px;">Чек</th>
                </tr>
          </template>
          <template class="body-2" slot="items" slot-scope="props">
              <td width="80" >{{ props.item.id }} {{ props.item.result == 1 ? "✅" : "❌" }} 
              <span style="font-size: 1.5em;"> {{ props.item.mail_check === 0 ? '📧' : ''}} </span></td>
              <td>{{ props.item.nick_name }}</td>
              <td  style="max-width: 30px;">{{ props.item.file_size }}</td>
              <td style="max-width: 170px;">{{ renderSender(props.item) }} <br>
                <b>{{ banksKeys[props.item.bank] }}</b></td>

              <td style="max-width: 170px;">{{ renderRemitte(props.item) }}<br><b>{{ props.item.receiver_bank }}</b></td>
              <td style="max-width: 50px;">{{ props.item.sum }}</td>
              <td style="max-width: 110px;">{{ props.item.payment_time }}</td>
              <td style="max-width: 110px;">{{ props.item.timestamp }}</td>
              <td style="max-width: 40px;"><a :href="'https://desk.bankpdf.ru/uploads/' + props.item.file + '.pdf'" target="_blank">Открыть</a></td>
              <td style="max-width: 50px;"><v-btn fab small flat class="grey" @click.native="cancel(props.item.id)" style="font-size: 8px;">
                <v-icon>cancel</v-icon>
              </v-btn></td>
          </template>
          <template slot="no-data">
           <span >
              <p class="pt-2 blue--text subheading">   <v-icon medium class="blue--text" >info</v-icon>Sorry, nothing to display here :(</p>
            </span>
          </template>
        </v-data-table>
        <div class="text-xs-center pt-2" v-if="isNotEmpty">
          <v-pagination v-model="pagination.page" :length="pagination.pages" :total-visible="10" circle></v-pagination>
        </div>
      </v-card>
    </v-flex>
  </v-container>
</template>
<script>
/* global Store */
import { mapState, dispatch } from 'vuex'
import auth from '../utils/auth'
import { upload } from "@/utils/file-upload.service";
const STATUS_INITIAL = 0;
const STATUS_SAVING = 1;
const STATUS_SUCCESS = 2;
const STATUS_FAILED = 3;

export default {
  props: ['dark'],
  data() {
    return {
      search: '',
      query: '',
      headers: [
        { text: '', value: 'result' },
        {
          text: 'ID проверки',
          left: true,
          value: 'id'
        },
        { text: 'Размер файла', value: 'file_size' },
        { text: 'Отправитель:', value: 'sender_name' },
        { text: 'Банк', value: 'bank' },
        { text: 'Получатель:', value: 'name' },
        { text: 'Банк:', value: 'receiver_bank' },
        { text: 'Сумма:', value: 'sum' },
        { text: 'Время платежа', value: 'payment_time' },
        { text: 'Время проверки', value: 'timestamp' },
        { text: 'Чек', value: 'file' },
      ],
      uploadFieldName: 'file',
      currentStatus: null,
      result: "",
    }
  },
    computed: {
      ...mapState("pdfchecks", {
        items: "checks",
        pagination: "pagination",
        loading: "loading",
        snackbar: "snackbar",
        notice: "notice"
      }),
      ...mapState(
        "filters", {
          from: "from",
          until: "until",
          fromTime: "fromTime",
          untilTime: "untilTime",
          banksKeys: "banksKeys",
          worker: "worker",
          bank: "bank",
      }),
      isNotEmpty () {
        return this.items && this.items.length > 0;
      },
      isInitial() {
          return this.currentStatus === STATUS_INITIAL;
      },
      isSaving() {
        return this.currentStatus === STATUS_SAVING;
      },
      isSuccess() {
        return this.currentStatus === STATUS_SUCCESS;
      },
      isFailed() {
        return this.currentStatus === STATUS_FAILED;
      }
    },
    methods: {
      getJSON() {
        const blob = new Blob([JSON.stringify(this.items)], { type: "text/plain" });
        const blobUrl = URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = blobUrl;
        link.download = this.from + "-" + this.until + ".json";
        document.body.appendChild(link);
        link.click();
        URL.revokeObjectURL(blobUrl);
        document.body.removeChild(link);
      },
      cancel(id) {
        Store.dispatch('pdfchecks/deleteCheck', id);
      },
      closeSnackbar() {
//        Store.commit("workers/setSnackbar", { snackbar: false });
        Store.commit("workers/setNotice", { notice: "" });
      },
      reloadData () {
        this.query = "from=" + this.from + "%20" + this.fromTime + "&until=" + this.until + "%20" + this.untilTime + "&worker=" + (this.worker || '') + "&bank=" + (this.bank || '');
        this.$Progress.start();
        Store.dispatch('pdfchecks/getChecks', this.query);
      },
      renderSender (item) {
        if (item.sender_name && item.sender_name !== '') {
          return item.sender_name;
        } else if (item.sender_tel && item.sender_tel !== '') {
          return item.sender_tel
        } else if (item.sender_acc && item.sender_acc !== '') {
          return item.sender_acc
        }
        return '';
      },
      renderRemitte (item) {
        if (item.receiver_tel && item.receiver_tel !== '') {
          return item.receiver_tel;
        } else if (item.receiver_name && item.receiver_name !== '') {
          return item.receiver_name
        } else if (item.receiver_acc && item.receiver_acc !== '') {
          return item.receiver_acc
        }
        return '';
      },
      save(formData) {
        this.currentStatus = STATUS_SAVING;
        upload(formData)
          .then(x => {
            if (x.data.message2) {
              alert(x.data.message2);
            }
            this.result = x.data.message
            this.currentStatus = STATUS_SUCCESS;
            this.reloadData();
          });
      },
      filesChange(fieldName, fileList) {
        const formData = new FormData();
        if (!fileList.length) return;
        Array
          .from(Array(fileList.length).keys())
          .map(x => {
            formData.append(fieldName, fileList[x], fileList[x].name);
          });
        // if (!confirm('Выполнить проверку файла: ' + fileList[0].name + ' ?')) return;

        this.save(formData);
        if (this.$refs.fileInput) this.$refs.fileInput.value = null;
      },
      reset() {
        this.currentStatus = STATUS_INITIAL;
        this.uploadedFiles = [];
        this.uploadError = null;
        this.$refs.fileInput.value = null;
      },
    },
    watch: {
      from() {
        this.reloadData();
      },
      until() {
        this.reloadData();
      },
      fromTime() {
        this.reloadData();
      },
      untilTime() {
        this.reloadData();
      },
      worker() {
        this.reloadData();
      },
      bank() {
        this.reloadData();
      },
      items() {
        this.$Progress.finish();
      },
    },
    created() {
      this.reloadData();
    },
    mounted() {
      this.reset();
    }
  }
</script>
<style scoped>

  .dropbox {
    outline: 2px dashed grey; /* the dash box */
    outline-offset: -10px;
    color: dimgray;
    padding: -10px 10px;
    min-height: 20px; /* minimum height */
    height: 70px; /* minimum height */
    position: relative;
    cursor: pointer;
    margin-top: -20px;
    font-size: 10px;
  }

  .dropbox-light {
    background: lightcyan;
  }
 
  .input-file {
    opacity: 0; /* invisible but it's there! */
    width: 100%;
    height: 80px;
/*    position: absolute; */
    cursor: pointer;
  }

  .dropbox:hover {
    background: lightblue; /* when mouse over to the drop zone, change color */
  }
  
  .dropbox p {
    font-size: 1.2em;
    text-align: center;
    margin-top: -80px;
    width: 600px;
    height: 80px;
    padding: 15px 0;
  }
</style>



// WEBPACK FOOTER //
// PDFChecks.vue?163a09ed